// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ArrowUp: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 7"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M.543 6.5h1c.269 0 .522-.101.682-.272L5.444 2.8c.13-.14.393-.14.524 0l3.218 3.428a.941.941 0 00.682.272h1.001c.277 0 .435-.252.27-.428L6.027.628a.467.467 0 00-.644 0L.274 6.071c-.167.177-.008.429.269.429"
            />
        </svg>
    );
};

export default React.memo(ArrowUp);
